import React, { useState, useEffect } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import {
  Button,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";

function TableView({ columns, data, customPageSize, onSelectionChange }) {
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useSortBy,
    usePagination
  );

  // Handle Select All Toggle
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedEmployeeIds([]);
    } else {
      // Select all Ids from the entire data, not just the current page
      const pendingEmployeeIds = data
      .filter(row => row.Status.props.children == 'Pending') // Filter only pending status
      .map(row => row.Id); 
      setSelectedEmployeeIds(pendingEmployeeIds);
    }
    setSelectAll(!selectAll);
  };
  

  // Handle Individual Selection
  const handleCheckboxChange = (employeeId,status) => {
    if(status.props.children == 'Pending')
    {
      setSelectedEmployeeIds((prevSelected) => {
        if (prevSelected.includes(employeeId)) {
          return prevSelected.filter((id) => id !== employeeId);
        } else {
          return [...prevSelected, employeeId];
        }
      });
      
    }
    else
    {
      setSelectedEmployeeIds((prevSelected) => { return [...prevSelected];});
    }
    
  };

  // Notify Parent Component (ListProcessLeaves.js)
  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(selectedEmployeeIds);
    }
  }, [selectedEmployeeIds, onSelectionChange]);

  useEffect(() => {
    setPageSize(customPageSize);
  }, [setPageSize, customPageSize]);

  return (
    <>
      <Row className="mb-2">
        <Col sm={2}>
          <select
            className="form-control"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[5, 10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
      </Row>

      <Table hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              <th>
                <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
              </th>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <i className="fas fa-sort ml-2"></i>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedEmployeeIds.includes(row.original.Id)}
                    onChange={() => handleCheckboxChange(row.original.Id,row.original.Status)}
                  />
                </td>
                {row.cells.map((cell) => (
                  
       <td {...cell.getCellProps()}>
  {cell.column.id === "Action" &&
  React.isValidElement(cell.value) &&
  cell.value.type === Button ? (
    React.cloneElement(cell.value, {
      disabled:
        selectedEmployeeIds.includes(row.original.Id) ||
          row.original.Status?.props?.children === "Approved" ||
  row.original.Status?.props?.children === "Rejected",
    })
  ) : (
    cell.render("Cell")
  )}
</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="table-pagination mt-3">
        <Col>
          <Pagination>
            <PaginationItem disabled={!canPreviousPage}>
              <PaginationLink first onClick={() => gotoPage(0)} />
            </PaginationItem>
            <PaginationItem disabled={!canPreviousPage}>
              <PaginationLink previous onClick={() => previousPage()} />
            </PaginationItem>
            <strong className="mt-1 mx-2">
              Page {pageIndex + 1} of {pageOptions.length}
            </strong>
            <PaginationItem disabled={!canNextPage}>
              <PaginationLink next onClick={() => nextPage()} />
            </PaginationItem>
            <PaginationItem disabled={!canNextPage}>
              <PaginationLink last onClick={() => gotoPage(pageCount - 1)} />
            </PaginationItem>
          </Pagination>
        </Col>
        <Col>
          <div className="input-group mb-3 float-right" style={{ width: "180px" }}>
            <div className="input-group-prepend">
              <label className="input-group-text">Go to page</label>
            </div>
            <input
              className="form-control"
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}

const TableWithSortPagtn = React.memo((props) => {
  const { thead, trow, onSelectionChange } = props;
  const columns = React.useMemo(() => thead.map((el) => ({ Header: el, accessor: el })), [thead]);
  const data = React.useMemo(() => trow, [trow]);

  return <TableView columns={columns} data={data} customPageSize={props.pageSize} onSelectionChange={onSelectionChange} />;
});

export default TableWithSortPagtn;